module.exports = __webpack_public_path__ + "img/Group 2146roundClose.d1dde780.svg";